import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import logo from "../assets/logo.png";

const Footer = () => {
  return (
    <footer className="bg-black text-white py-12">
      <div className="px-4 md:px-8 lg:px-12 max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <img
              src={logo}
              alt="X7 Autoz"
              className="h-14 w-auto mb-4"
            />
            <p className="text-secondary-400 text-sm leading-relaxed">
              Your trusted marketplace for certified pre-owned vehicles. Connecting buyers and sellers since 2026.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/browse" className="text-secondary-400 hover:text-primary-400 transition-colors">Browse Vehicles</Link></li>
              <li><Link to="/upload-vehicle" className="text-secondary-400 hover:text-primary-400 transition-colors">Sell Your Vehicle</Link></li>
              <li><Link to="/blogs" className="text-secondary-400 hover:text-primary-400 transition-colors">Blogs</Link></li>
              <li><Link to="/about" className="text-secondary-400 hover:text-primary-400 transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="text-secondary-400 hover:text-primary-400 transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Categories</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/browse?type=car" className="text-secondary-400 hover:text-primary-400 transition-colors">Cars</Link></li>
              <li><Link to="/browse?type=bike" className="text-secondary-400 hover:text-primary-400 transition-colors">Bikes</Link></li>
              <li><Link to="/browse?type=ev" className="text-secondary-400 hover:text-primary-400 transition-colors">Electric Vehicles</Link></li>
              <li><Link to="/browse?type=commercial" className="text-secondary-400 hover:text-primary-400 transition-colors">Commercial</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm text-secondary-400">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4" />
                support@x7autoz.com
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4" />
                +91 9110823599
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="h-4 w-4" />
                Belgaum, Karnataka
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-secondary-400 text-sm">
            © 2026 X7 Autoz. All rights reserved.
          </p>
          <div className="flex gap-4 mt-4 md:mt-0">
            <a href="#" className="text-secondary-400 hover:text-primary-400 transition-colors">
              <Facebook className="h-5 w-5" />
            </a>
            <a href="#" className="text-secondary-400 hover:text-primary-400 transition-colors">
              <Twitter className="h-5 w-5" />
            </a>
            <a href="#" className="text-secondary-400 hover:text-primary-400 transition-colors">
              <Instagram className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
